import { IconBase, IconComponent } from './BaseIcon';

export const Cart: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M4.3 7H2V5h2.4c.3 0 .6 0 1 .2a3 3 0 0 1 1.9 2.2l.1.6h23A53286.8 53286.8 0 0 0 27 18.7a3 3 0 0 1-2.5 1.4H10l.6 2.9H26a3.5 3.5 0 0 1 3.5 3.5c0 2-1.6 3.5-3.5 3.5a3.5 3.5 0 0 1-3.1-5H12.2a3.5 3.5 0 1 1-3.6-2c-1-5-1.9-10.2-3.3-15.3a1 1 0 0 0-1-.7ZM26 25c-.4 0-.8.2-1 .4a1.5 1.5 0 1 0 1-.4ZM9 25c-.4 0-.7.2-1 .4a1.5 1.5 0 1 0 1.1-.4ZM8 10l1.7 8c5 0 10 .3 15 0a1 1 0 0 0 .9-.7l2.2-7.3H7.9Z" />
  </IconBase>
);
